var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotelIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 38.75,
    height: 38.75,
    rx: 19.375,
    stroke: "#0066CC",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 11.998H12.001C11.4705 11.998 10.9618 12.2088 10.5868 12.5838C10.2117 12.9589 10.001 13.4676 10.001 13.998V27.998C10.001 28.5285 10.2117 29.0372 10.5868 29.4123C10.9618 29.7873 11.4705 29.998 12.001 29.998H26.001C26.5314 29.998 27.0401 29.7873 27.4152 29.4123C27.7903 29.0372 28.001 28.5285 28.001 27.998V20.998",
    stroke: "#0066CC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.501 10.4983C26.8988 10.1004 27.4384 9.87695 28.001 9.87695C28.5636 9.87695 29.1032 10.1004 29.501 10.4983C29.8988 10.8961 30.1223 11.4357 30.1223 11.9983C30.1223 12.5609 29.8988 13.1004 29.501 13.4983L20.001 22.9983L16.001 23.9983L17.001 19.9983L26.501 10.4983Z",
    stroke: "#0066CC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotelIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notelIcon.a821fc7bffa83e7836bc334f85a334de.svg";